/* Trendmagazin als Blog-Artikel (Unboxing 2.0). Port des Skripts aus
   dashboard/scripts/trendmagazin/magazin.html.j2. Unterschiede zum Original:
   - Daten (Wert, Ersparnis, Hör-Kapitel, Sprungmarken) aus <script id="tbTmDaten"> statt Jinja,
   - keine eigene Kopfleiste (Theme-Header), Kopfhöhe aus der CSS-Variable --tm-top,
   - Messung an die absolute Reporting-URL (seit 03.10.2026, nur auf trend-box.de),
   - Demo-Formulare (Bewerten-Sheet, Abstimmung, Gewinnspiel) entfallen, die Seite verlinkt ins Portal,
   - jeder optionale Abschnitt darf fehlen (Null-Prüfungen). */

/* Modul „Quiz“ (Wisch dich schlau, Alex 31.10.2026). Eigenständig und VOR dem Hauptskript, weil dieses mit
   „Bewegung reduzieren“ früh zurückkehrt. Daten aus <script id="tbTmQuiz"> (a.quiz): karten[] mit art
   (wahrfalsch | mehrweniger), kategorie, frage, antwort (true = wahr/mehr), erklaerung, bild, bild_alt; optional
   code, code_text. Wischen nach rechts = wahr/mehr, nach links = falsch/weniger; Knöpfe und Pfeiltasten (Fokus im Quiz)
   als Alternative. Keine Messung, keine Speicherung. */
(function(){
  var app = document.getElementById('qzApp'), jEl = document.getElementById('tbTmQuiz');
  if (!app || !jEl) return;
  var Q = {};
  try { Q = JSON.parse(jEl.textContent); } catch (e) { return; }
  var K = (Q.karten || []).filter(function(k){ return k && k.frage; }).slice(0, 8);
  if (!K.length) return;
  var BOX = app.getAttribute('data-box') || 'Trendbox';
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var H = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>';
  var i = 0, pts = 0, serie = 0, best = 0, ok = [], busy = false, laeuft = false;
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bildUrl(u){ return /^https:\/\//.test(u || '') ? esc(u) : ''; }
  function labels(k){ return k.art === 'mehrweniger' ? ['Weniger', 'Mehr'] : ['Falsch', 'Wahr']; }
  function kopieren(txt, b, fertig){
    var fehl = function(){ b.textContent = 'Markieren und kopieren'; };
    try { navigator.clipboard.writeText(txt).then(function(){ b.textContent = fertig; }, fehl); } catch (e) { fehl(); }
  }
  function intro(){
    laeuft = false; busy = false;
    app.innerHTML = '<p class="qz-hin">Wische die Karte nach rechts für wahr oder mehr und nach links für falsch oder weniger. Oder tippe die Knöpfe. ' + K.length + ' Karten.</p><div class="qz-aktion"><button type="button" class="qz-btn" id="qzGo">Los geht’s</button></div>';
    document.getElementById('qzGo').onclick = start;
  }
  function start(){
    i = 0; pts = 0; serie = 0; best = 0; ok = []; busy = false; laeuft = true;
    var prog = '<div class="qz-prog" id="qzProg" aria-hidden="true">'; K.forEach(function(){ prog += '<i></i>'; }); prog += '</div>';
    app.innerHTML = prog + '<div class="qz-hud"><span class="se">Serie <b id="qzSe">0</b></span><span id="qzZl">Karte 1 von ' + K.length + '</span><span>Punkte <b id="qzPt">0</b></span></div><div class="qz-deck" id="qzDeck"></div><div class="qz-knoepfe"><button type="button" class="qz-btn qz-l" id="qzBl">' + X + '<span id="qzTl">Falsch</span></button><button type="button" class="qz-btn qz-r" id="qzBr">' + H + '<span id="qzTr">Wahr</span></button></div><div class="qz-blitz" id="qzBz" aria-live="polite"></div>';
    document.getElementById('qzBl').onclick = function(){ antwort(false); };
    document.getElementById('qzBr').onclick = function(){ antwort(true); };
    deck();
  }
  function deck(){
    var d = document.getElementById('qzDeck'); if (!d) return;
    d.innerHTML = '';
    for (var n = 2; n >= 0; n--) {
      if (i + n >= K.length) continue;
      var k = K[i + n], lb = labels(k), u = bildUrl(k.bild);
      var c = document.createElement('div');
      c.className = 'qz-kk' + (n === 1 ? ' b1' : n === 2 ? ' b2' : '');
      c.innerHTML = '<div class="qz-bild">' + (u ? '<img src="' + u + '" alt="' + esc(k.bild_alt) + '" draggable="false"' + (n === 0 ? '' : ' loading="lazy"') + '>' : '') + '<span class="qz-art">' + esc(k.kategorie) + '</span><span class="qz-stempel qz-st-r">' + lb[1] + '</span><span class="qz-stempel qz-st-l">' + lb[0] + '</span></div><div class="qz-txt"><div class="qz-frage">' + esc(k.frage) + '</div><div class="qz-hint"><span>← ' + lb[0] + '</span><span>' + lb[1] + ' →</span></div></div>';
      d.appendChild(c);
    }
    var lb0 = labels(K[i]);
    document.getElementById('qzTl').textContent = lb0[0]; document.getElementById('qzTr').textContent = lb0[1];
    document.getElementById('qzZl').textContent = 'Karte ' + (i + 1) + ' von ' + K.length;
    var pr = document.getElementById('qzProg').children; for (var p = 0; p < pr.length; p++) pr[p].className = p < i ? 'an' : '';
    var top = d.lastElementChild; top.setAttribute('tabindex', '0'); top.setAttribute('aria-label', K[i].frage + ' Pfeil rechts: ' + lb0[1] + ', Pfeil links: ' + lb0[0]);
    drag(top);
  }
  function drag(c){
    var x0 = null, dx = 0;
    c.addEventListener('pointerdown', function(e){ if (busy) return; x0 = e.clientX; dx = 0; c.classList.add('zieh'); try { c.setPointerCapture(e.pointerId); } catch (err) {} });
    c.addEventListener('pointermove', function(e){
      if (x0 === null) return;
      dx = e.clientX - x0; c.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 16) + 'deg)';
      var a = Math.min(1, Math.abs(dx) / 90);
      c.querySelector(dx > 0 ? '.qz-st-r' : '.qz-st-l').style.opacity = a;
      c.querySelector(dx > 0 ? '.qz-st-l' : '.qz-st-r').style.opacity = 0;
    });
    function los(){
      if (x0 === null) return;
      c.classList.remove('zieh'); var d = dx; x0 = null; dx = 0;
      if (Math.abs(d) > 90) antwort(d > 0);
      else { c.style.transform = ''; var st = c.querySelectorAll('.qz-stempel'); for (var s = 0; s < st.length; s++) st[s].style.opacity = 0; }
    }
    c.addEventListener('pointerup', los); c.addEventListener('pointercancel', los);
  }
  function antwort(w){
    if (busy || !laeuft) return; busy = true;
    var k = K[i], richtig = (w === !!k.antwort);
    var d = document.getElementById('qzDeck'), top = d.lastElementChild;
    top.classList.remove('zieh');
    top.querySelector(w ? '.qz-st-r' : '.qz-st-l').style.opacity = 1;
    top.style.transform = 'translateX(' + (w ? 460 : -460) + 'px) rotate(' + (w ? 20 : -20) + 'deg)'; top.style.opacity = '0';
    if (richtig) { serie++; best = Math.max(best, serie); pts += 10 + Math.min(serie - 1, 4) * 2; } else { serie = 0; }
    ok.push(richtig);
    document.getElementById('qzSe').textContent = serie; document.getElementById('qzPt').textContent = pts;
    document.getElementById('qzBz').innerHTML = '<div class="qz-erkl ' + (richtig ? 'ja' : 'nein') + '"><strong>' + (richtig ? 'Richtig' : 'Daneben') + '</strong>' + esc(k.erklaerung) + '</div>';
    setTimeout(function(){ i++; busy = false; if (i >= K.length) ende(); else deck(); }, richtig ? 700 : 1200);
  }
  function ende(){
    laeuft = false;
    var n = ok.filter(Boolean).length, m = K.length, r = n / m;
    var tier = r >= .85 ? 'Wisch-Profi' : r >= .55 ? 'Gutes Händchen' : 'Weiter wischen';
    var h = '<div class="qz-erg"><span class="qz-pill">Geschafft</span><h3>' + tier + '</h3><p class="lede">' + n + ' von ' + m + ' richtig, ' + pts + ' Punkte, längste Serie ' + best + '.</p><ul class="qz-rech">';
    K.forEach(function(k, j){ h += '<li class="' + (ok[j] ? '' : 'x') + '"><i>' + (ok[j] ? '+' : 'x') + '</i><span>' + esc(k.frage) + '</span></li>'; });
    h += '</ul>';
    if (Q.code) h += '<div class="qz-code"><div><small>' + esc(Q.code_text || 'Dein Dankeschön') + '</small><b>' + esc(Q.code) + '</b></div><button type="button" class="qz-btn zweit" id="qzCp" style="min-height:44px;padding:0 18px;font-size:15px">Kopieren</button></div>';
    h += '<div class="qz-aktion"><button type="button" class="qz-btn" id="qzTeil">Ergebnis teilen</button><button type="button" class="qz-btn zweit" id="qzNochmal">Nochmal wischen</button></div></div>';
    app.innerHTML = h;
    var cp = document.getElementById('qzCp'); if (cp) cp.onclick = function(){ kopieren(String(Q.code), cp, 'Kopiert'); };
    document.getElementById('qzTeil').onclick = function(){ kopieren(n + ' von ' + m + ' beim Wisch-Quiz der ' + BOX + '. Schaffst du mehr?', this, 'Text kopiert'); };
    document.getElementById('qzNochmal').onclick = start;
  }
  app.addEventListener('keydown', function(e){
    if (!laeuft) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); antwort(true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); antwort(false); }
  });
  intro();
})();

(function(){
  var root = document.querySelector('.tb-tm');
  var datenEl = document.getElementById('tbTmDaten');
  if (!root || !datenEl) return;
  var DATEN = {};
  try { DATEN = JSON.parse(datenEl.textContent); } catch (e) {}
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T0 = function(){ return parseFloat(getComputedStyle(root).getPropertyValue('--tm-top')) || 0; };
  var clamp = function(v, a, b){ if (a == null) a = 0; if (b == null) b = 1; return Math.max(a, Math.min(b, v)); };
  var ease = function(t){ return 1 - Math.pow(1 - t, 3); };
  var eio = function(t){ return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var eo = ease, lerp = function(a, b, t){ return a + (b - a) * t; };
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var eur = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var WERT = +DATEN.wert || 0, SPAR = +DATEN.spar || 0; // je Platz der günstigere Preis, inkl. Goodie: was jede Kundin mindestens bekommt (rechnet boxplan)
  var num = new Intl.NumberFormat('de-DE');
  function sticky(el){ var r = el.getBoundingClientRect(); var t = r.height - innerHeight; return t > 0 ? clamp(-r.top / t) : 0; }
  function pass(el){ var r = el.getBoundingClientRect(); return clamp((innerHeight - r.top) / (innerHeight + r.height)); }
  function toast(msg){ var t = $('#toast'); t.textContent = msg; t.classList.add('show'); clearTimeout(toast._t); toast._t = setTimeout(function(){ t.classList.remove('show'); }, 2200); }
  function countUp(el, to, fmt, ms){ if (reduce) { el.textContent = fmt(to); return; } var t0 = performance.now(); (function k(n){ var t = clamp((n - t0) / (ms || 1500)); el.textContent = fmt(to * ease(t)); if (t < 1) requestAnimationFrame(k); })(t0); }

  /* Messung (03.10.2026): was gelesen, gehört, geklickt wird. Nur Tagessummen je Ausgabe, Gerät,
     Ereignis und Ziel, keine Personendaten, kein Cookie (Sammelstelle reporting
     /api/public/trendmagazin/ereignis, Auswertung /trendmagazin-auswertung). Jedes Ereignis zählt
     einmal pro Aufruf. Nur auf trend-box.de: Vorschauen und Theme-Editor zählen nicht mit. sendBeacon
     mit Text-Körper ist eine einfache Anfrage ohne CORS-Vorabprüfung; die Antwort braucht niemand. */
  var MESS_URL = 'https://reporting.trend-box.de/api/public/trendmagazin/ereignis';
  var MESS_AN = /(^|\.)trend-box\.de$/.test(location.hostname) && !(window.Shopify && Shopify.designMode) && /^[a-z]+-\d{4}$/.test(DATEN.ausgabe || '');
  var gemessen = {}, puffer = [];
  function mess(e, z){ if (!MESS_AN) return; var k = e + '|' + (z || ''); if (gemessen[k]) return; gemessen[k] = 1; puffer.push([e, String(z || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40)]); }
  function senden(){
    if (!puffer.length) return;
    var body = JSON.stringify({ a: DATEN.ausgabe, e: puffer }); puffer = [];
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(MESS_URL, body))) fetch(MESS_URL, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function(){}); } catch (e) {}
  }
  if (MESS_AN) {
    mess('aufruf');
    setInterval(senden, 8000);
    addEventListener('pagehide', senden);
    document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') senden(); });
    addEventListener('scroll', function(){ var f = (scrollY + innerHeight) / document.documentElement.scrollHeight; [25, 50, 75].forEach(function(s){ if (f >= s / 100) mess('scroll', String(s)); }); if (f >= .98) mess('scroll', '100'); }, { passive: true });
    // Sektion zählt, sobald sie die Bildschirmmitte kreuzt (auch die hohen Sticky-Sektionen)
    if ('IntersectionObserver' in window) { var mio = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) mess('sektion', e.target.id); }); }, { rootMargin: '-50% 0px -50% 0px' }); $$('.tb-tm section[id]').forEach(function(s){ mio.observe(s); }); }
    // Klicks: fester Name per data-mess, Produktknöpfe mit Produktschlüssel
    root.addEventListener('click', function(ev){
      var el = ev.target.closest && ev.target.closest('a,button'); if (!el) return;
      var st = el.closest('.step, .fcard'), k = st ? (st.dataset.k || st.id.replace(/^p-/, '')) : '';
      if (el.dataset.mess) mess('klick', el.dataset.mess);
      else if (st && /Bewerten/.test(el.textContent)) mess('klick', 'bewerten-' + k);
      else if (el.id === 'tmrBtn') mess('klick', 'timer');
      else if (el.id === 'codeBtn') mess('klick', 'code-kopiert');
      else if (el.closest('.seg')) mess('klick', 'goodie-' + el.dataset.abo);
      else if (el.id === 'playBtn' || el.id === 'miniBtn') mess('klick', 'hoeren-knopf');
    }, true);
  }

  /* 1 · Intro „Lautwort“: durchs O in die Box, dann fliegen die Produkte in die Kategorie-Kacheln */
  var hero = $('#hero'), stage = $('#stage'), stats = $('#stats');
  var bxIn = $('#bxIn'), bxBox = $('#bxBox'), bxWord = $('#bxWord');
  var bxT = $$('.bx-tbg').map(function(bg, i){ return { bg: bg, fg: $$('.bx-tfg')[i], snd: $('.snd', bg) }; });
  var bxP = $$('.bx-p').map(function(el, i){ return { el: el, ci: +el.dataset.kat, j: +el.dataset.j, n: +el.dataset.n, ar: 1.2, i: i }; });
  var BX = {}, statsDone = false;
  var ei3 = function(t){ return t * t * t; };
  var rndB = function(i, k){ var x = Math.sin(i * 127.1 + k * 311.7) * 43758.5453; return x - Math.floor(x); };
  function bxLayout(){
    var W = innerWidth, H = innerHeight, hoch = H > W * 1.1, T = T0(); // Höhe des klebenden Theme-Headers (kopfMessen)
    BX.W = W; BX.H = H; BX.hoch = hoch;
    bxP.forEach(function(it){ var im = it.el.firstChild; if (im.naturalWidth) it.ar = im.naturalHeight / im.naturalWidth; });
    // Lautwort: hochkant zweizeilig, das erste O (sonst der mittlere Buchstabe) ist das Guckloch
    var wort = bxWord.dataset.wort, oi = wort.indexOf('O'); if (oi < 0) oi = Math.floor(wort.length / 2);
    var teile = hoch && wort.length > 4 ? [wort.slice(0, Math.ceil(wort.length / 2)), wort.slice(Math.ceil(wort.length / 2))] : [wort], pos = 0;
    bxWord.innerHTML = teile.map(function(z){ var h = z.split('').map(function(ch, k){ return pos + k === oi ? '<i id="bxO" style="font-style:normal">' + ch + '</i>' : ch; }).join(''); pos += z.length; return '<span>' + h + '</span>'; }).join('');
    stage.style.setProperty('--fs', '100px'); bxWord.style.transform = 'none';
    var r100 = bxWord.getBoundingClientRect();
    stage.style.setProperty('--fs', Math.min(100 * W * .9 / (r100.width || 1), 100 * (H - T) * (hoch ? .5 : .4) / (r100.height || 1)) + 'px');
    bxWord.style.top = (T + (H - T) * (hoch ? .42 : .44)) + 'px';
    // Bühnen-Koordinaten: vor dem Ankleben liegt die Bühne unter Header + Breadcrumb, im Viewport gemessen
    // saß die Box um diese Höhe unter dem O (Lene 16.10.2026)
    var wr = bxWord.getBoundingClientRect(), orr = $('#bxO').getBoundingClientRect(), sr = stage.getBoundingClientRect();
    BX.ox = orr.left - sr.left + orr.width / 2; BX.oy = orr.top - sr.top + orr.height * .47; BX.rx = orr.width * .2; BX.ry = orr.height * .27;
    stage.style.setProperty('--tox', (BX.ox - (wr.left - sr.left)) + 'px'); stage.style.setProperty('--toy', (BX.oy - (wr.top - sr.top)) + 'px');
    stage.style.setProperty('--ox', BX.ox + 'px'); stage.style.setProperty('--oy', BX.oy + 'px');
    bxWord.style.transform = '';
    // Box: im O klein, nach dem Zoom groß in der Mitte
    var bar = bxBox.naturalWidth ? bxBox.naturalHeight / bxBox.naturalWidth : 1.2;
    BX.bw = Math.min(W * (hoch ? .96 : .6), (H - T) * .86 / bar); BX.bar = bar;
    // Kacheln unter der Frage, Größe nach Menge
    var top = T + (hoch ? 12 : 20) + Math.min(52, Math.max(28, Math.min(W, H) * .05)) + 14, pad = hoch ? 14 : 20, gap = hoch ? 10 : 14, bot = hoch ? 14 : 20;
    $('#bxAsk').style.top = (T + (hoch ? 10 : 18)) + 'px';
    var wts = bxT.map(function(t, i){ return .6 + Math.sqrt(bxP.filter(function(p){ return p.ci === i; }).length) * .3; });
    var sum = wts.reduce(function(a, b){ return a + b; }, 0), acc = 0;
    bxT.forEach(function(t, i){
      var r;
      if (hoch) { var hh = (H - top - bot - gap * (bxT.length - 1)) * wts[i] / sum; r = { x: pad, y: top + acc, w: W - 2 * pad, h: hh }; acc += hh + gap; }
      else { var ww = (W - 2 * pad - gap * (bxT.length - 1)) * wts[i] / sum; r = { x: pad + acc, y: top, w: ww, h: H - top - bot }; acc += ww + gap; }
      t.r = r;
      [t.bg, t.fg].forEach(function(e){ e.style.left = r.x + 'px'; e.style.top = r.y + 'px'; e.style.width = r.w + 'px'; e.style.height = r.h + 'px'; });
      // Lautwort als Streifen oben in der Kachel, komplett sichtbar; die Produkte liegen darunter, nicht darauf
      var n0 = bxP.filter(function(p){ return p.ci === i; }).length;
      t.seite = hoch && n0 <= 3;
      t.snd.style.fontSize = '100px';
      var sw = t.snd.getBoundingClientRect().width || 1;
      var maxW = t.seite ? r.w * .46 - 18 : r.w * .92, maxH = t.seite ? r.h * .34 : r.h * (hoch ? .22 : .14);
      var cs = Math.min(100 * maxW / sw, maxH / .8);
      t.snd.style.fontSize = cs + 'px'; t.sw = sw * cs / 100;
      t.bandBot = r.h * .05 + cs * .8;
      t.bg.style.setProperty('--st', (r.h * .05 + cs * .4) + 'px');
      t.cx0 = t.seite ? 18 : (r.w - t.sw) / 2;
    });
    // Zielplätze in den Kacheln: „ausgeschüttet“ (gefächert, überlappend, gedreht)
    bxP.forEach(function(it){
      var tt = bxT[it.ci], r = tt.r, n = it.n, j = it.j, seite = tt.seite, y0;
      var ar2 = seite ? { x: r.w * .5, y: r.h * .06, w: r.w * .46, h: r.h * .94 - 62 }
        : !hoch ? (y0 = tt.bandBot + r.h * .03, { x: r.w * .06, y: y0, w: r.w * .88, h: r.h - 96 - y0 })
        : (y0 = tt.bandBot + 6, { x: r.w * .04, y: y0, w: r.w * .92, h: r.h - 72 - y0 });
      // Größe so, dass auch das größte, gedrehte Produkt innerhalb der Fläche bleibt
      var h = Math.min(ar2.h * (hoch ? .78 : .55), ar2.w / Math.max(1.6, n * .48) * 1.45);
      var hh = h * (.82 + rndB(j + it.ci * 7, 5) * .3), ww = hh / it.ar, step = n > 1 ? (ar2.w - ww) / (n - 1) : 0;
      var cx = n === 2 ? ar2.x + ar2.w * (j ? .7 : .3) : ar2.x + ww / 2 + step * j;
      var cy = ar2.y + ar2.h * (!hoch ? (j % 2 ? .64 : .36) : (j % 2 ? .53 : .47));
      it.t = { x: r.x + cx, y: r.y + cy, s: ww, r: (rndB(j + it.ci * 5, 7) - .5) * 22 };
      it.z = 10 - Math.abs(j - (n - 1) / 2) | 0;
      // Start: in der Box (Mitte der großen Box, etwas oberhalb)
      it.s0 = { x: W / 2 + (rndB(it.i, 8) - .5) * BX.bw * .5, y: T + (H - T) / 2 - BX.bw * bar * .1 + (rndB(it.i, 9) - .5) * BX.bw * .3 };
    });
  }
  function bxPlace(it, x, y, s, r, o){
    it.el.style.width = s + 'px';
    it.el.style.transform = 'translate(' + (x - s / 2).toFixed(1) + 'px,' + (y - s * it.ar / 2).toFixed(1) + 'px) rotate(' + r.toFixed(2) + 'deg)';
    it.el.style.opacity = o.toFixed(3);
  }
  function drawHero(p){
    if (!BX.W) return;
    var W = BX.W, H = BX.H, T = T0();
    stage.style.setProperty('--hi', (1 - clamp(p / .04)).toFixed(2));
    stage.style.setProperty('--so2', (1 - clamp(p / .08)).toFixed(2));
    // 0–.36: durchs O zoomen
    var z = clamp(p / .36), zs = Math.pow(60, ei3(z));
    stage.style.setProperty('--ws', zs.toFixed(3));
    stage.style.setProperty('--wo', (1 - clamp((z - .8) / .2)).toFixed(3));
    stage.style.setProperty('--rx', (BX.rx * zs).toFixed(1) + 'px');
    stage.style.setProperty('--ry', (BX.ry * zs).toFixed(1) + 'px');
    bxIn.classList.toggle('full', z >= 1);
    // Box: klein im O, wächst mit dem Zoom zur vollen Größe; ab .5 geht sie auf (Produkte fliegen raus), dann weg
    var grow = lerp(BX.rx * 2.2 / BX.bw, 1, eio(z)), out = eio(clamp((p - .52) / .16));
    var bs = grow * (1 - out * .3), bw = BX.bw;
    bxBox.style.width = bw + 'px';
    bxBox.style.transform = 'translate(' + (lerp(BX.ox, W / 2, eio(z)) - bw / 2).toFixed(1) + 'px,' + (lerp(BX.oy, T + (H - T) / 2, eio(z)) - bw * BX.bar / 2).toFixed(1) + 'px) scale(' + bs.toFixed(4) + ')';
    bxBox.style.opacity = (1 - out).toFixed(3);
    // Box-Moment: Wert und Ersparnis (.38–.5)
    var so = eo(clamp((p - .37) / .06)) * (1 - clamp((p - .5) / .06));
    stage.style.setProperty('--so', so.toFixed(2));
    if (so > .5 && !statsDone){ statsDone = true; countUp($('#stWert'), WERT, function(v){ return eur.format(v) + ' €'; }); countUp($('#stSpar'), SPAR, function(v){ return eur.format(v) + ' €'; }); }
    bxT.forEach(function(t, i){
      var a = eio(clamp((p - .52 - i * .06) / .2));
      t.bg.style.setProperty('--cr', a.toFixed(3));
      t.bg.style.setProperty('--cx', (t.cx0 + (1 - a) * t.r.w * .8).toFixed(1) + 'px');
      var lo = eo(clamp((p - .72 - i * .04) / .12));
      t.fg.style.setProperty('--lo', lo.toFixed(3));
      t.fg.classList.toggle('on', lo > .9);
      t.fg.tabIndex = lo > .9 ? 0 : -1;
    });
    stage.style.setProperty('--ao', eo(clamp((p - .76) / .12)).toFixed(3));
    bxP.forEach(function(it){
      var f = eio(clamp((p - .54 - it.ci * .06 - it.j * .012) / .2));
      var x = lerp(it.s0.x, it.t.x, f), y = lerp(it.s0.y, it.t.y, f) - Math.sin(f * Math.PI) * H * .08;
      bxPlace(it, x, y, lerp(it.t.s * .5, it.t.s, f), it.t.r * f, clamp(f * 4));
      it.el.style.zIndex = String(40 + it.z);
    });
  }
  // Geometrie erst mit geladenen Bildern (Seitenverhältnisse) und Ginto (Wortbreite)
  if (hero && bxBox && bxWord) Promise.all([bxBox].concat(bxP.map(function(it){ return it.el.firstChild; })).map(function(im){ return im.decode ? im.decode().catch(function(){}) : null; }))
    .then(function(){ return document.fonts ? document.fonts.ready : null; })
    .then(function(){ bxLayout(); drawHero(reduce ? 1 : sticky(hero)); });
  var bxW = innerWidth, bxH = innerHeight;
  // Handy-Adressleiste ändert beim Scrollen die Höhe: nur bei echter Größenänderung neu rechnen
  if (hero && bxBox && bxWord) addEventListener('resize', function(){ if (innerWidth === bxW && Math.abs(innerHeight - bxH) < 140) return; bxW = innerWidth; bxH = innerHeight; bxLayout(); drawHero(reduce ? 1 : sticky(hero)); });

  /* 1b · Beautybox-Intro „Swatch“ (03.10.2026): Titel und Box, dann malen sich drei Farbstriche (je Kategorie
     einer) über den Bildschirm, die Produkte springen auf ihren Strich, die Striche sind die Kapitelwahl. */
  var swStage = $('#swStage'), swSvg = $('#swSvg'), swBox = $('#swBox');
  var swS = swStage ? $$('path', swSvg).map(function(path, i){ return { path: path, band: $$('.sw-band')[i] }; }).filter(function(s){ return s.band; }) : [];
  var swP = swStage ? $$('.sw-p').map(function(el){ return { el: el, ci: +el.dataset.kat, j: +el.dataset.j, n: +el.dataset.n, ar: 1 }; }) : [];
  var SW = {};
  function swLayout(){
    var W = innerWidth, H = innerHeight, hoch = H > W, T = T0(), top = T + (hoch ? 70 : 84), gap = hoch ? 8 : 12;
    SW.W = W; SW.H = H;
    swSvg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    swP.forEach(function(it){ var im = it.el.firstChild; if (im.naturalWidth) it.ar = im.naturalHeight / im.naturalWidth; });
    var bandH = (H - top - 16 - gap * (swS.length - 1)) / Math.max(1, swS.length);
    swS.forEach(function(s, i){
      var y = top + i * (bandH + gap) + bandH / 2, dick = bandH * 1.04, wob = bandH * .08;
      // leicht gewellt wie mit dem Finger gezogen, jeder zweite Strich von rechts
      var von = i % 2 ? W + dick * .2 : -dick * .2, bis = i % 2 ? -dick * .2 : W + dick * .2;
      s.path.setAttribute('d', 'M' + von + ' ' + (y + wob) + ' C ' + (W * .3) + ' ' + (y - wob * 2) + ', ' + (W * .7) + ' ' + (y + wob * 2) + ', ' + bis + ' ' + (y - wob));
      s.path.setAttribute('stroke-width', dick);
      s.len = s.path.getTotalLength(); s.path.style.strokeDasharray = s.len; s.y = y; s.h = bandH;
      s.band.style.top = (y - bandH / 2) + 'px'; s.band.style.width = W + 'px'; s.band.style.height = bandH + 'px';
    });
    var boxR = swBox.getBoundingClientRect();
    swP.forEach(function(it){
      var s = swS[it.ci]; if (!s) return;
      var h = s.h * (hoch ? .6 : .76), w = h / it.ar, maxW = (hoch ? W * .5 : W * .22) / it.n * 1.3;
      if (w > maxW) { w = maxW; h = w * it.ar; }
      var l = W * (hoch ? .46 : .42), r = hoch ? W - 16 : W * .78;
      it.t = { x: it.n === 1 ? (l + r) / 2 : l + (r - l) * ((it.j + .5) / it.n), y: s.y - s.h * (hoch ? .1 : .05), w: w, r: (it.j - (it.n - 1) / 2) * 6 };
      it.s = { x: W / 2, y: T + (H - T) * .58, w: w * .4 };
    });
  }
  var swStats = false;
  function swDraw(p){
    if (!SW.W) return;
    var st = swStage;
    st.style.setProperty('--hi', (1 - clamp(p / .04)).toFixed(2));
    st.style.setProperty('--so2', (1 - clamp(p / .08)).toFixed(2));
    // .05–.26: Wert und Ersparnis unter der Box
    var so = eo(clamp((p - .05) / .06)) * (1 - clamp((p - .22) / .06));
    st.style.setProperty('--so', so.toFixed(2));
    if (so > .5 && !swStats){ swStats = true; countUp($('#stWert'), WERT, function(v){ return eur.format(v) + ' €'; }); countUp($('#stSpar'), SPAR, function(v){ return eur.format(v) + ' €'; }); }
    // .2–.4: Titel und Box treten zurück
    var weg = eio(clamp((p - .2) / .2));
    st.style.setProperty('--to', (1 - weg).toFixed(3)); st.style.setProperty('--ty', (-weg * 60) + 'px');
    st.style.setProperty('--bs', (1 - weg * .55).toFixed(3)); st.style.setProperty('--br', (weg * -8) + 'deg');
    st.style.setProperty('--bo', (1 - clamp((p - .4) / .1)).toFixed(3));
    // .3–.76: drei Striche nacheinander, danach Beschriftung und Frage
    swS.forEach(function(s, i){
      var f = eio(clamp((p - .3 - i * .12) / .22));
      s.path.style.strokeDashoffset = (s.len * (1 - f)).toFixed(1);
      // runde Strichenden würden sonst schon vor dem Malen am Rand hervorschauen
      s.path.style.opacity = f > .002 ? '1' : '0';
      var lo = eo(clamp((p - .76 - i * .03) / .1));
      s.band.style.setProperty('--lo', lo.toFixed(3)); s.band.classList.toggle('on', lo > .9); s.band.tabIndex = lo > .9 ? 0 : -1;
    });
    st.style.setProperty('--ao', eo(clamp((p - .8) / .1)).toFixed(3));
    swP.forEach(function(it){
      if (!it.t) return;
      var f = eio(clamp((p - .44 - it.ci * .12 - it.j * .03) / .2));
      var x = lerp(it.s.x, it.t.x, f), y = lerp(it.s.y, it.t.y, f) - Math.sin(f * Math.PI) * SW.H * .1, w = lerp(it.s.w, it.t.w, f);
      it.el.style.width = w + 'px';
      it.el.style.transform = 'translate(' + (x - w / 2).toFixed(1) + 'px,' + (y - w * it.ar / 2).toFixed(1) + 'px) rotate(' + (it.t.r * f).toFixed(1) + 'deg)';
      it.el.style.opacity = clamp((p - .44 - it.ci * .12) / .03).toFixed(2);
    });
  }
  if (swStage && hero) Promise.all([swBox].concat(swP.map(function(it){ return it.el.firstChild; })).map(function(im){ return im.decode ? im.decode().catch(function(){}) : null; }))
    .then(function(){ return document.fonts ? document.fonts.ready : null; })
    .then(function(){ swLayout(); swDraw(reduce ? 1 : sticky(hero)); });
  if (swStage && hero) addEventListener('resize', function(){ if (innerWidth === bxW && Math.abs(innerHeight - bxH) < 140) return; bxW = innerWidth; bxH = innerHeight; swLayout(); swDraw(reduce ? 1 : sticky(hero)); });

  /* Kopfhöhe des Shops messen (live 01.10.2026): Der Theme-Header klebt doch, eingeklappt 71 px am Handy und
     59 px am Desktop. Mit --tm-top: 0 lagen Intro-Frage und Kapitel-Bühnen darunter. Ist der Header oben
     angedockt, zählt seine Unterkante, sonst seine Höhe; ändert sich der Wert, wird das Intro neu gelegt. */
  var kopf = document.querySelector('.site-header-container'), kopfT = -1;
  function kopfMessen(){
    if (!kopf) return;
    var r = kopf.getBoundingClientRect(), t = Math.max(0, Math.min(160, Math.round(r.top <= 1 ? r.bottom : r.height)));
    if (t === kopfT) return;
    kopfT = t; root.style.setProperty('--tm-top', t + 'px');
    if (BX.W && hero && bxBox && bxWord) { bxLayout(); drawHero(reduce ? 1 : sticky(hero)); }
    if (SW.W && hero) { swLayout(); swDraw(reduce ? 1 : sticky(hero)); }
  }
  kopfMessen();
  var kopfReq = false;
  addEventListener('scroll', function(){ if (kopfReq) return; kopfReq = true; requestAnimationFrame(function(){ kopfReq = false; kopfMessen(); }); }, { passive: true });
  addEventListener('resize', kopfMessen);

  /* 2 · Hör-Reise (nur wenn boxplan MP3s geliefert hat: jedes Kapitel mit src) */
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var CUES = DATEN.sprungmarken || [];
  var CH = (DATEN.kapitel || []).filter(function(k){ return k && k.src; }).map(function(k, i){
    // thumbs sind Keys („skoen“, „box“) oder schon URLs; Keys über DATEN.bilder auflösen, Unbekanntes weglassen
    var BILD = DATEN.bilder || {}, th = (k.thumbs || []).map(function(t){ return /:\/\//.test(t) ? t : BILD[t]; }).filter(Boolean);
    return { title: k.titel, sub: k.sub, thumbs: th, anchor: k.anchor, src: k.src, dur: +k.dur || 0, cues: CUES[i] || [] };
  });
  var audio = $('#audio'), chsEl = $('#chs'), cur = 0, follow = true, started = false;
  if (audio && chsEl && CH.length) (function(){
  var fmtT = function(s){ s = Math.max(0, Math.round(s || 0)); return Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2); };
  CH.forEach(function(c, i){
    var li = document.createElement('li');
    var thumbs = c.thumbs.map(function(u){ return '<img src="' + esc(u) + '" alt="">'; }).join('');
    li.innerHTML = '<button type="button"><span class="n">' + (i + 1) + '</span><span class="tt">' + esc(c.title) + '<small>' + esc(c.sub) + '</small></span><span class="thumbs">' + thumbs + '</span><span class="d">' + fmtT(c.dur) + '</span></button>';
    li.querySelector('button').addEventListener('click', function(){ load(i, true); });
    chsEl.appendChild(li);
  });
  var lis = $$('li', chsEl);
  function load(i, play){
    cur = i; audio.src = CH[i].src; started = true;
    lis.forEach(function(li, j){ li.classList.toggle('on', j === i); });
    $('#nowKick').textContent = 'Kapitel ' + (i + 1) + ' von ' + CH.length; $('#nowTitle').textContent = CH[i].title;
    $('#miniKick').textContent = 'Hör-Reise · Kapitel ' + (i + 1); $('#miniTitle').textContent = CH[i].title;
    $('#tAll').textContent = fmtT(CH[i].dur);
    lastCue = -1;
    if (play) { mess('hoeren_start'); mess('hoeren_start', 'k' + (i + 1)); audio.play(); if (follow && CH[i].anchor) goTo(CH[i].anchor); }
    updateMini();
  }
  function isVisible(el){ var r = el.getBoundingClientRect(); return r.top < innerHeight * .6 && r.bottom > innerHeight * .3; }
  /* Sprungziel: „#id“ oder „#sticky-sektion@0.35“ (Anteil durch eine Sticky-Sektion, z. B. die Food-Galerie) */
  function goTo(anchor){
    var parts = anchor.split('@'), el = document.querySelector(parts[0]); if (!el) return;
    var how = reduce ? 'auto' : 'smooth';
    if (parts.length > 1) { scrollTo({ top: el.getBoundingClientRect().top + scrollY + Math.max(0, el.offsetHeight - innerHeight) * +parts[1], behavior: how }); return; }
    if (isVisible(el)) return;
    el.scrollIntoView({ behavior: how, block: el.classList.contains('step') ? 'center' : 'start' });
  }
  /* Innerhalb eines Kapitels: bei jeder Sprungmarke mitblättern (Feedback Michelle 22.09.) */
  var lastCue = -1;
  function followCues(){
    var cues = CH[cur].cues || [], k = -1;
    for (var j = 0; j < cues.length; j++) if (audio.currentTime >= cues[j].t) k = j;
    if (k !== lastCue) { lastCue = k; if (k >= 0 && follow && !audio.paused) goTo(cues[k].anchor); }
  }
  $('#tAll').textContent = fmtT(CH[0].dur);
  function toggle(){ if (!started) { load(0, true); return; } if (audio.paused) audio.play(); else audio.pause(); }
  $('#playBtn').addEventListener('click', toggle); $('#miniBtn').addEventListener('click', toggle);
  $('#miniNext').addEventListener('click', function(){ if (cur < CH.length - 1) load(cur + 1, true); });
  /* Nach dem letzten Kapitel zurück an den Anfang, damit man selbst noch mal von vorn liest (Lene 01.10.) */
  audio.addEventListener('ended', function(){ mess('hoeren_ende', 'k' + (cur + 1)); if (cur < CH.length - 1) { load(cur + 1, true); return; } syncIcons(); if (follow) { mess('hoeren_ende', 'nach-oben'); setTimeout(function(){ scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); }, 700); } });
  var PLAY = '<path d="M8 5v14l11-7z"/>', PAUSE = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>';
  function syncIcons(){ var on = !audio.paused; $$('.pic').forEach(function(s){ s.innerHTML = on ? PAUSE : PLAY; }); ['#playBtn', '#miniBtn'].forEach(function(id){ $(id).setAttribute('aria-label', on ? 'Hör-Reise pausieren' : 'Hör-Reise abspielen'); }); updateMini(); }
  audio.addEventListener('play', syncIcons); audio.addEventListener('pause', syncIcons);
  audio.addEventListener('timeupdate', function(){ var d = audio.duration || CH[cur].dur, f = audio.currentTime / d; $('#barFill').style.width = (f * 100).toFixed(2) + '%'; $('#miniFill').style.width = (f * 100).toFixed(2) + '%'; $('#tNow').textContent = fmtT(audio.currentTime); $('#bar').setAttribute('aria-valuenow', Math.round(f * 100)); followCues(); });
  $('#bar').addEventListener('click', function(e){ if (!started) return; var r = this.getBoundingClientRect(); audio.currentTime = clamp((e.clientX - r.left) / r.width) * (audio.duration || CH[cur].dur); });
  $('#bar').addEventListener('keydown', function(e){ if (!started) return; if (e.key === 'ArrowRight') audio.currentTime += 5; if (e.key === 'ArrowLeft') audio.currentTime -= 5; });
  var sw = $('#followSw'); sw.addEventListener('click', function(){ follow = !follow; sw.setAttribute('aria-checked', follow ? 'true' : 'false'); });
  /* Wer selbst scrollt, liest selbst: Mitblättern geht aus, sonst zieht die nächste Sprungmarke die Seite zurück (Lene 02.10.) */
  function selbstGescrollt(){ if (!follow || audio.paused) return; follow = false; sw.setAttribute('aria-checked', 'false'); mess('klick', 'mitblaettern-aus-selbst'); toast('Mitblättern aus, du scrollst selbst'); }
  addEventListener('wheel', selbstGescrollt, { passive: true }); addEventListener('touchmove', selbstGescrollt, { passive: true });
  addEventListener('keydown', function(e){ if (/^(ArrowDown|ArrowUp|PageDown|PageUp|Home|End| )$/.test(e.key) && !e.target.closest('button, input, textarea, [role="slider"], .up-slider')) selbstGescrollt(); });
  var playerVisible = true;
  new IntersectionObserver(function(es){ playerVisible = es[0].isIntersecting; updateMini(); }).observe($('#player'));
  function updateMini(){ var show = started && !playerVisible && !(audio.paused && audio.currentTime === 0); $('#mini').classList.toggle('show', show); $('#mini').setAttribute('aria-hidden', show ? 'false' : 'true'); }
  })();

  /* 3 · Editorial */
  var ed = $('#editorial'), edText = $('#edText'), spans = [], edFliesst = matchMedia('(max-width: 700px)');
  if (edText) {
    var hl = {}; (edText.dataset.hl || '').split('|').forEach(function(w){ if (w) hl[w] = 1; });
    var words = edText.textContent.trim().split(/\s+/); edText.textContent = '';
    spans = words.map(function(w, i){ var s = document.createElement('span'); s.className = 'w' + (hl[w.replace(/[.,!]/g, '')] ? ' hl' : ''); s.textContent = w; edText.appendChild(s); if (i < words.length - 1) edText.appendChild(document.createTextNode(' ')); return s; });
  }
  function drawEd(p){ var n = spans.length; spans.forEach(function(s, i){ s.style.setProperty('--on', clamp((p * 1.35 * n - i) / 2.5).toFixed(2)); }); }

  /* 4 · Goodie */
  $$('#goodie .seg button').forEach(function(b){ b.addEventListener('click', function(){
    $$('#goodie .seg button').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    $$('#goCards > [data-for]').forEach(function(c){ var show = c.dataset.for.split(' ').indexOf(b.dataset.abo) >= 0 && !c.hasAttribute('data-aus'); c.hidden = !show; if (show) { c.style.animation = 'none'; void c.offsetWidth; c.style.animation = ''; } });
  }); });
  // Splitting: Umschalter in der Karte zeigt die andere Variante desselben Platzes (16.10.2026)
  $$('#goCards .gvar button').forEach(function(b){ b.addEventListener('click', function(){
    var alt = b.closest('.gcard'), neu = $('#goCards .gcard[data-gruppe="' + alt.dataset.gruppe + '"][data-key="' + b.dataset.zeige + '"]');
    if (!neu || neu === alt) return;
    alt.setAttribute('data-aus', ''); alt.hidden = true;
    neu.removeAttribute('data-aus'); neu.hidden = false;
    var f = $('.gvar button[data-zeige="' + b.dataset.zeige + '"]', neu); if (f) f.focus({ preventScroll: true });
  }); });

  /* Lautwort auf verfügbare Breite/Höhe einpassen: nie abgeschnitten, nie unter einem Produkt */
  function fitSnd(el, maxW, maxH){
    if (!el || !el.textContent.trim()) return;
    el.style.fontSize = '100px';
    var w = el.getBoundingClientRect().width || 1, pad = parseFloat(getComputedStyle(el).paddingLeft) * 2 || 0;
    el.style.fontSize = Math.max(28, Math.min(100 * (maxW - pad) / (w - pad), maxH / .8)) + 'px';
  }
  function fitChap(snd){ if (!snd) return; var st = snd.parentNode; fitSnd(snd, st.clientWidth * .94, Math.min(170, st.clientHeight * (innerWidth <= 900 ? .24 : .2))); }
  function fitCards(){ $$('.tb-tm .fcard .snd').forEach(function(s){ fitSnd(s, s.parentNode.clientWidth, 56); }); fitFood(); }
  /* Food-Bühne: Bildhöhe = was nach Überschrift, Balken und der längsten Karte übrig bleibt (110–330 px).
     Vorher ragte die Karte bei langen Texten oben und unten aus der Bühne (Lene 02.10.) */
  function fitFood(){
    $$('.tb-tm .fd-stage').forEach(function(st){
      var tr = $('.track', st), cards = tr ? $$('.fcard', tr) : []; if (!cards.length) return;
      st.style.removeProperty('--fimg'); st.classList.remove('fd-eng', 'fd-enger', 'fd-ohne-laut');
      var cs = getComputedStyle(st), gap = parseFloat(cs.rowGap) || 0;
      function freiFuersBild(){
        var maxB = 0, rest = 0;
        cards.forEach(function(c){ var b = $('.b', c); if (b) maxB = Math.max(maxB, b.scrollHeight); });
        [].forEach.call(st.children, function(k){ if (k !== tr) rest += k.offsetHeight; });
        return st.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - rest - gap * (st.children.length - 1) - maxB;
      }
      /* Ausformulierte Trendfaktoren machen die Karten länger: bevor das Produktbild zur Briefmarke wird,
         kürzt sich der Produkttext in zwei Stufen (Live-Check 02.10.) */
      var frei = freiFuersBild();
      if (frei < 180) { st.classList.add('fd-eng'); frei = freiFuersBild(); }
      if (frei < 150) { st.classList.add('fd-enger'); frei = freiFuersBild(); }
      // Unter 180 px frisst das Lautwort fast das ganze Bildfeld: dann nur das Produkt zeigen
      if (frei < 180) st.classList.add('fd-ohne-laut');
      st.style.setProperty('--fimg', Math.round(Math.max(110, Math.min(330, frei))) + 'px');
    });
  }

  /* 5 · Kapitel */
  var narrow = matchMedia('(max-width: 900px)').matches;
  $$('.tb-tm .chap').forEach(function(sec){
    var steps = $$('.step', sec), imgs = $$('.ch-photo img', sec), snd = $('.ch-snd', sec), cnt = $('.ch-count', sec);
    if (!steps.length) return;
    function act(st){
      steps.forEach(function(s){ s.classList.toggle('on', s === st); });
      imgs.forEach(function(im){ im.classList.toggle('on', im.dataset.k === st.dataset.k); });
      sec.style.setProperty('--bg', st.dataset.bg);
      if (snd && snd.textContent !== st.dataset.snd){ snd.style.opacity = 0; setTimeout(function(){ snd.textContent = st.dataset.snd; fitChap(snd); snd.style.opacity = 1; }, 180); }
      if (cnt) cnt.textContent = ('0' + (steps.indexOf(st) + 1)).slice(-2) + ' / ' + ('0' + steps.length).slice(-2);
    }
    act(steps[0]);
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) act(e.target); }); }, { rootMargin: narrow ? '-62% 0px -37% 0px' : '-45% 0px -45% 0px' });
    steps.forEach(function(s){ io.observe(s); });
    sec._snd = snd;
  });
  /* Editorial-Bühne: Text so groß wie möglich, aber Text + Kompass passen auf den Bildschirm. Vorher ragte der Text
     am Handy oben in die Hör-Reise und unten schnitt das Goodie den Kompass ab, am Desktop fehlten die Kompass-Zeilen (Lene 02.10.) */
  function fitEd(){
    var st = ed && $('.ed-stage', ed); if (!st || !edText || getComputedStyle(st).position !== 'sticky') { if (edText) edText.style.fontSize = ''; return; }
    edText.style.fontSize = '';
    var cs = getComputedStyle(st), gap = parseFloat(cs.rowGap) || 0, rest = 0, n = 0;
    [].forEach.call(st.children, function(k){ n++; if (k !== edText) rest += k.offsetHeight; });
    var frei = st.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - rest - gap * (n - 1);
    var lo = 18, hi = parseFloat(getComputedStyle(edText).fontSize);
    if (edText.offsetHeight <= frei) return;
    for (var i = 0; i < 8; i++) { var m = (lo + hi) / 2; edText.style.fontSize = m + 'px'; if (edText.offsetHeight <= frei) lo = m; else hi = m; }
    edText.style.fontSize = Math.floor(lo) + 'px';
  }
  /* Team: großer Name auf die Bildspalte eingepasst, statt über die Überschrift daneben zu laufen (Lene 02.10.) */
  function fitTeam(){ var nm = $('.tb-tm .tm-name'); if (nm) fitSnd(nm, nm.parentNode.clientWidth * .96, 210 * .8); }
  function fitAll(){ $$('.tb-tm .chap').forEach(function(sec){ fitChap(sec._snd); }); fitCards(); fitEd(); fitTeam(); }
  fitAll();
  if (document.fonts) document.fonts.ready.then(fitAll);
  var fitW = innerWidth, fitH = innerHeight; addEventListener('resize', function(){ if (innerWidth !== fitW) { fitW = innerWidth; fitH = innerHeight; fitAll(); } else if (Math.abs(innerHeight - fitH) > 140) { fitH = innerHeight; fitFood(); fitEd(); } });

  /* 6 · Galerien (waagerechte Karten, z. B. Food). Weg bis zum rechten Rand der letzten Karte plus Innenabstand */
  var gals = $$('.tb-tm .gal').map(function(sec){ var track = $('.track', sec); return { sec: sec, track: track, last: track && $('.fcard:last-child', track), bar: $('.fd-bar', sec) }; }).filter(function(g){ return g.track && g.last; });
  function drawGal(g){ var p = sticky(g.sec), dist = Math.max(0, g.last.offsetLeft + g.last.offsetWidth + parseFloat(getComputedStyle(g.track).paddingLeft) - innerWidth); g.track.style.setProperty('--gx', (eio(p) * dist).toFixed(1)); if (g.bar) g.bar.style.setProperty('--gp', p.toFixed(3)); }

  /* 8 · Rezept */
  var rz = $('#rzVis'), tBtn = $('#tmrBtn'), tEl = $('#tmr'), iv = null;
  var dauerTimer = tEl ? +tEl.dataset.sek : 0, left = dauerTimer;
  function drawRz(p){ if (!rz) return; rz.style.setProperty('--rx', ((.5 - p) * 300).toFixed(1) + 'px'); rz.style.setProperty('--ry', ((.5 - p) * 60).toFixed(1)); }
  if (tBtn && tEl) tBtn.addEventListener('click', function(){
    if (iv) { clearInterval(iv); iv = null; tBtn.textContent = 'Timer fortsetzen'; return; }
    if (left <= 0) left = dauerTimer;
    tBtn.textContent = 'Timer pausieren';
    iv = setInterval(function(){ left--; tEl.textContent = Math.floor(left / 60) + ':' + ('0' + left % 60).slice(-2); if (left <= 0) { clearInterval(iv); iv = null; tBtn.textContent = 'Nochmal ' + Math.round(dauerTimer / 60) + ' Minuten'; var s1 = $('#s1'); if (s1) s1.checked = true; toast(tEl.dataset.fertig); } }, 1000);
  });

  /* 10 · Upcycling / Bild-Slider: Pfeile, Punkte, Schritt antippen, wischen, Pfeiltasten (Lene 01.10., Heft bdf1583) */
  var up = $('#upcycling');
  if (up && $('#upVis')) (function(){
    var imgs = $$('.up-visual img', up), lis = $$('#upSteps li'), dots = $$('#upDots button'), prev = $('#upPrev'), next = $('#upNext'), n = lis.length, i = 0;
    function show(k, quelle){
      k = clamp(k, 0, n - 1); if (k === i) return; i = k;
      imgs.forEach(function(im, j){ im.classList.toggle('on', j === i); if (j === i) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true'); });
      lis.forEach(function(li, j){ li.classList.toggle('on', j === i); var b = li.querySelector('button'); if (j === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
      dots.forEach(function(d, j){ if (j === i) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current'); });
      prev.disabled = i === 0; next.disabled = i === n - 1;
      mess('klick', 'diy-schritt-' + (i + 1) + (quelle ? '-' + quelle : ''));
    }
    prev.addEventListener('click', function(){ show(i - 1, 'pfeil'); });
    next.addEventListener('click', function(){ show(i + 1, 'pfeil'); });
    dots.forEach(function(d, j){ d.addEventListener('click', function(){ show(j, 'punkt'); }); });
    lis.forEach(function(li, j){ li.querySelector('button').addEventListener('click', function(){ show(j, 'text'); }); });
    $('.up-slider', up).addEventListener('keydown', function(e){ if (e.key === 'ArrowLeft') { show(i - 1, 'taste'); e.preventDefault(); } if (e.key === 'ArrowRight') { show(i + 1, 'taste'); e.preventDefault(); } });
    var vis = $('#upVis'), x0 = null, y0 = 0;
    vis.addEventListener('pointerdown', function(e){ x0 = e.clientX; y0 = e.clientY; });
    vis.addEventListener('pointerup', function(e){ if (x0 === null) return; var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(i + (dx < 0 ? 1 : -1), 'wischen'); });
    vis.addEventListener('pointercancel', function(){ x0 = null; });
  })();

  /* 11 · Herzen + Zähler */
  var cio = new IntersectionObserver(function(es){ es.forEach(function(e){ if (!e.isIntersecting) return; cio.unobserve(e.target); var el = e.target; countUp(el, +el.dataset.count, function(v){ return (el.dataset.prefix || '') + num.format(Math.round(v)); }, 1600); }); }, { threshold: .5 });
  $$('.tb-tm [data-count]').forEach(function(el){ cio.observe(el); });
  var heartsBox = $('#hearts'), hearts = $$('.tb-tm .heart .hi');

  /* 12 · Team + Ersparnis */
  var tmName = $('.tb-tm .tm-name'), team = $('#team'), spar = $('#spNums'), burst = $('.tb-tm .burst');
  if (spar) { var sio = new IntersectionObserver(function(es){ if (!es[0].isIntersecting) return; sio.disconnect(); countUp($('#spSave'), SPAR, function(v){ return '+' + eur.format(v) + ' €'; }, 1600); countUp($('#spTotal'), WERT, function(v){ return eur.format(v) + ' €'; }, 1600); }, { threshold: .5 }); sio.observe(spar); }

  /* 13 · Code kopieren (Ausblick) */
  function copy(text, msg){ try { navigator.clipboard.writeText(text).then(function(){ toast(msg); }, function(){ toast(msg); }); } catch (e) { toast(msg); } }
  var codeBtn = $('#codeBtn'); if (codeBtn) codeBtn.addEventListener('click', function(){ var c = this.dataset.code; copy(c, 'Code ' + c + ' kopiert'); });
  // Gutschein der Marke am Produkt (03.10.2026)
  $$('.tm-gs-copy').forEach(function(b){ b.addEventListener('click', function(){ var c = this.dataset.code; copy(c, 'Code ' + c + ' kopiert'); }); });
  var friends = $('#friends img'), auVis = $('#auVis'), paImg = $('#paImg');

  /* Unboxing-Video: YouTube lädt erst nach Klick (vorher keine Verbindung zu YouTube) */
  /* Teaser: eigene MP4, lädt erst beim Abspielen (preload=none); Hör-Reise und Teaser pausieren sich gegenseitig */
  var teVid = $('#teVid');
  if (teVid) {
    $('#tePlay').addEventListener('click', function(){ teVid.play(); });
    teVid.addEventListener('play', function(){ mess('klick', 'video-teaser'); if (audio && !audio.paused) audio.pause(); teVid.parentNode.classList.add('playing'); teVid.controls = true; });
    if (audio) audio.addEventListener('play', function(){ if (!teVid.paused) teVid.pause(); });
  }

  var vidPlay = $('#vidPlay');
  if (vidPlay) vidPlay.addEventListener('click', function(){
    var box = this.closest('.vid'), f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.yt) + '?autoplay=1&playsinline=1&rel=0';
    f.title = 'Trendbox Unboxing'; f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
    if (audio && !audio.paused) audio.pause();
    box.innerHTML = ''; box.classList.add('playing'); box.appendChild(f);
    var b2 = $('#vidPlay2'); if (b2) b2.hidden = true;
  });
  /* Knopf in der Textspalte (Desktop) startet dasselbe Video in der Karte */
  var vidPlay2 = $('#vidPlay2');
  if (vidPlay && vidPlay2) vidPlay2.addEventListener('click', function(){ vidPlay.click(); });

  /* Hinweis im Ersparnis-Block springt zur Goodie-Ansicht „Kein Goodie in der Box?“ */
  $$('.tb-tm [data-abo-jump]').forEach(function(a){ a.addEventListener('click', function(){ var b = $('#goodie .seg button[data-abo="' + a.dataset.aboJump + '"]'); if (b) b.click(); }); });

  /* Ablauf */
  if (reduce) { if ($('#stWert')) $('#stWert').textContent = eur.format(WERT) + ' €'; if ($('#stSpar')) $('#stSpar').textContent = eur.format(SPAR) + ' €'; drawEd(1); return; }
  var q = false;
  function frame(){
    q = false;
    if (hero) (swStage ? swDraw : drawHero)(sticky(hero));
    if (ed) drawEd(edFliesst.matches ? clamp((pass(edText) - .15) / .45) : sticky(ed));
    gals.forEach(drawGal); drawRz(rz ? pass($('#rezept')) : 0);
    if (paImg) paImg.style.setProperty('--pp', pass(paImg).toFixed(3));
    if (heartsBox) { var hp = pass(heartsBox); hearts.forEach(function(h, i){ h.style.setProperty('--hp', clamp(hp * 2.2 - i * .15).toFixed(3)); }); }
    if (tmName && team) tmName.style.setProperty('--dx', ((.5 - pass(team)) * 50).toFixed(1) + 'px');
    if (burst && spar) burst.style.setProperty('--br', ((pass(spar) - .5) * 40).toFixed(1));
    if (friends) friends.style.setProperty('--fr', ((pass(friends) - .5) * -16).toFixed(1));
    if (auVis) { var ap = pass(auVis); auVis.style.setProperty('--ar', (ap * 60).toFixed(1)); auVis.style.setProperty('--ay', ((1 - ap) * 60).toFixed(1)); }
  }
  function req(){ if (!q) { q = true; requestAnimationFrame(frame); } }
  addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); frame();
})();
